export const GET_BANK_LIST = "GET_BANK_LIST";
export const GET_BANK_LIST_SUCCESS = "GET_BANK_LIST_SUCCESS";
export const GET_BANK_LIST_FAILED = "GET_BANK_LIST_FAILED";
export const STORE_INVESTMENT_DETAILS = "STORE_INVESTMENT_DETAILS";
export const STORE_FATCA_DETAILS = "STORE_FATCA_DETAILS";
export const STORE_SCHEME_DETAILS = "STORE_SCHEME_DETAILS";
export const STORE_SCHEME_PARAMS = "STORE_SCHEME_PARAMS";
export const STORE_APPLICANT_PARAMS = "STORE_APPLICANT_PARAMS";
export const STORE_INVESTMENT_PARAMS = "STORE_INVESTMENT_PARAMS";
export const STORE_NOMINEE_DETAILS = "STORE_NOMINEE_DETAILS";
export const STORE_PAN = "STORE_PAN";
export const CLEARING_FIRST_TIME_INVETOR_JOURNEY_SUCCESS =
  "CLEARING_FIRST_TIME_INVETOR_JOURNEY_SUCCESS"; 
